module.exports = __webpack_public_path__ + "img/246-india.f4d1cde7.svg";